import React from 'react'
import env from './../../../../environments/environment'
import './HeroSection.component.scss'

const HeroSection = () => {
  return (
    <section className='hero-section'>
      <div className='hero-section__inner'>
        <div className='hero-section__content'>
          <h1 className='hero-section__headline'>
            <span>Health Insurance Solutions, Tailored for You</span>
          </h1>
          <p className='hero-section__subtext'>
            At <strong>USA Benefits Group</strong>, we connect you with experienced independent agents who design
            personalized health and life insurance solutions that fit your needs and budget — serving individuals,
            families, and small businesses since 1988.
          </p>
          <div className='hero-section__cta-group hero-section__cta-group--desktop'>
            <a href='/our-licensed-agents' className='hero-section__cta-btn' target='_blank' rel='noopener noreferrer'>
              <span>Find An Agent</span>
            </a>
            <a href='/careers' className='hero-section__cta-btn' target='_blank' rel='noopener noreferrer'>
              <span>Join Our Agency</span>
            </a>
          </div>
          <div className='hero-section__cta-group hero-section__cta-group--mobile'>
            <a href='/our-licensed-agents' className='hero-section__cta-btn' target='_blank' rel='noopener noreferrer'>
              <span>Find An Agent</span>
            </a>
            <a href='/careers' className='hero-section__cta-btn' target='_blank' rel='noopener noreferrer'>
              <span>Join Our Agency</span>
            </a>
          </div>
        </div>
        <div className='hero-section__image'>
          <img
            src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fwebsite%2Fimg.hero-family.png?alt=media`}
            alt="Doctor examining a young patient's heart with parents present in an exam room."
            width='940'
            height='788'
          />
        </div>
      </div>
    </section>
  )
}

export default HeroSection
